export enum ApplicationSharingLevelEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Shared = 'SHARED',
}
